import useUpgradesStore from "@/store/useUpgradesStore";
import type { UpgradeParams } from "@/types/tile";
import { FrameName } from "../config";
import { EventUpgradeIds } from "../config/upgrades/";
import TileEntity from "../TileEntity";

class MountainsTerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MOUNTAINS;

	public get upgrades(): Map<FrameName, UpgradeParams> {
		if (this.cachedUpgrades) return this.cachedUpgrades;

		const upgrades = new Map<FrameName, UpgradeParams>(
			super.config.upgrades,
		);

		if (
			useUpgradesStore().getCurrentLevelById(
				EventUpgradeIds.ch_highlanders,
			) > 0
		) {
			upgrades.set(FrameName.DARKWOOD_LUMBER_MILL, {
				// Budova ide zo storage.
			});
		}

		return (this.cachedUpgrades = new Map<FrameName, UpgradeParams>(
			upgrades,
		));
	}
}

export default MountainsTerrainTileEntity;
